module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0523ce6fadf10b29e98a428525307259.png";